import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useEffect, useState } from "react";

type Props = {
  open: boolean;
  requestNo: string;
  loading?: boolean;
  onClose: () => void;
  onConfirm: (rejectReason: string) => void | Promise<void>;
};

export function TransferRejectDialog({
  open,
  requestNo,
  loading,
  onClose,
  onConfirm,
}: Props) {
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (open) setReason("");
  }, [open]);

  const handleClose = () => {
    if (loading) return;
    setReason("");
    onClose();
  };

  const trimmed = reason.trim();
  const canSubmit = trimmed.length >= 3;

  return (
    <Dialog open={open} onOpenChange={(next) => !next && handleClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>ປະຕິເສດຄຳຂໍເບິກ</DialogTitle>
          <DialogDescription>
            {requestNo} — ຕ້ອງລະບຸເຫດຜົນກ່ອນປະຕິເສດ (ສາຂາຈະເຫັນໃນລະບົບ POS).
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Label htmlFor="reject-reason">ເຫດຜົນປະຕິເສດ</Label>
          <Textarea
            id="reject-reason"
            placeholder="ຕົວຢ່າງ: ສະຕ໋ອກ Hub ບໍ່ພໍ · ລາຍການບໍ່ຖືກຕ້ອງ"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            className="min-h-[100px]"
          />
          {!canSubmit && reason.length > 0 && (
            <p className="text-destructive text-xs">
              ກະລຸນາໃສ່ຢ່າງໜ້ອຍ 3 ຕົວອັກສອນ
            </p>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={handleClose} disabled={loading}>
            ຍົກເລີກ
          </Button>
          <Button
            variant="destructive"
            disabled={!canSubmit}
            isLoading={loading}
            onClick={() => void onConfirm(trimmed)}
          >
            ຢືນຢັນປະຕິເສດ
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
